import camelCase from './camel-case';
import capitalize from './capitalize';
import cover from './cover';
import coverEmpty from './cover-empty';
import currencySign from './currency-sign';
import debounce from './debounce';
import deepClone from './deep-clone';
import getCommaSeparated from './get-comma-separated';
import getIdentifier from './getIdentifier';
import humanizeDuration from './humanize-duration';
import isBlank from './is-blank';
import isEmpty from './is-empty';
import isEqual from './is-equal';
import isJSONString from './is-json-string';
import isNotEmpty from './is-not-empty';
import isObject from './is-object';
import isValidISODate from './is-valid-date';
import isXMLString from './is-xml-string';
import join from './join';
import lengthEquals from './lengthEquals';
import monetize from './monetize';
import monetizeExplicit from './monetize-explicit';
import ordinal from './ordinal';
import objectToQueryString from './object-to-query-string';
import parseNumerical from './parse-numerical';
import pluralize from './pluralize';
import pick from './pick';
import range from './range';
import restorePrimitive from './restore-primitive';
import separateArray from './separate-array';
import stringToXML from './string-to-xml';
import stripHTML from './strip-html';
import trim from './trim';
import truncate from './truncate';
import unCamelCase from './un-camel-case';
import unCapitalize from './un-capitalize';
import unKebabCase from './un-kebab-case';
import nbsp from './nbsp';

export default {
    camelCase,
    capitalize,
    cover,
    coverEmpty,
    currencySign,
    debounce,
    deepClone,
    getCommaSeparated,
    getIdentifier,
    humanizeDuration,
    isBlank,
    isEmpty,
    isEqual,
    isJSONString,
    isNotEmpty,
    isObject,
    isValidISODate,
    isXMLString,
    join,
    lengthEquals,
    monetize,
    monetizeExplicit,
    ordinal,
    objectToQueryString,
    parseNumerical,
    pluralize,
    pick,
    range,
    restorePrimitive,
    separateArray,
    stringToXML,
    stripHTML,
    trim,
    truncate,
    unCamelCase,
    unCapitalize,
    unKebabCase,
    nbsp,
};
